import { makeStyles } from '@mui/styles';

export default makeStyles({
    title: { marginRight: '.75rem' },
    icon: { width: '32px' }
});